import React, { useEffect, useState } from 'react'
import TableStepper from './StepperComponent'
import { Box, CircularProgress, Collapse, Grid, makeStyles, TableCell, TableRow, Typography } from '@material-ui/core'
import BatchDetailsRow from './BatchDetailsRow'
import axios from 'axios'
import { appUrl } from '../../../../../../utils/config'

const useStyles = makeStyles((theme) => ({
    root: {
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(3),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        // width: '100%',
        // backgroundColor: '#EDEDED',
    },
}))


const BatchDetailsUnitBox = (props) => {
  const { open, sample, workitemData } = props;
  const classes = useStyles()
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [batchUnitData, setBatchUnitData] = useState(null);
  const [batchSampleData, setBatchSampleData] = useState(null)
  
  useEffect(() => {
    let data = {
      schrockenDeliveryScheduleBatchID: 0,
      collabrixWorkItemID: workitemData.collabrixWorkItemID,
    }
    if (sample) {
      axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchBatchQCSamplingDetails`,
      data
    )
    .then((res) => {
      if (res.data.status) {
        setIsLoading(false)
        setBatchSampleData(res.data.data)
      } else {
        setIsLoading(false)
        setError(true)
      }
    })
        .catch((err) => {
          setError(true)
          setIsLoading(false)
          console.log(err)
        });
    } else {
      axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchBatchUnitOperationDetails`,
      data
    )
    .then((res) => {
      if (res.data.status) {
        setIsLoading(false)
        setBatchUnitData(res.data.data)
      } else {
        setIsLoading(false)
        setError(true)
      }
    })
    .catch((err) => {
      setError(true)
      setIsLoading(false)
      console.log(err)
    });
    }
  },[workitemData.collabrixWorkItemID])

  return (
    <>
    <TableRow>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center", // Horizontally center the CircularProgress
                alignItems: "center", // Vertically center the CircularProgress
                height: "100px", // Optional: Set a height to vertically center the loader
              }}
            >
              <CircularProgress />
            </div>
          ) : (
              <Box margin={1}>
                {/* <BatchDetailsUnitBox /> */}
                  <Grid container spacing={3}>
                    {error ? <Box className={classes.root} style={{width:'100%',border: '2px solid #FF0000',
                backgroundColor: '#FFF0F0'}}>
                        <Typography style={{textAlign:'center'}}>Something went wrong. Please try again.</Typography>
                    </Box> :
                      (batchUnitData && Object.keys(batchUnitData).length !== 0) || (batchSampleData && Object.keys(batchSampleData).length !== 0)
                      ? <Box className={classes.root}>
                      {batchUnitData && !sample && <>
                        <BatchDetailsRow data={batchUnitData} />
                        <TableStepper batchData={batchUnitData} stepperData={batchUnitData.unitOperationDetails} workitemData={workitemData} />
                      </>}
                      {batchSampleData && sample && <>
                        <BatchDetailsRow data={batchSampleData} />
                        <TableStepper batchData={batchSampleData} stepperData={batchSampleData.qcSamplingDetails} workitemData={workitemData} sample={true} />
                      </>}
                    </Box> : <Box className={classes.root} style={{width:'100%'}}>
                        <Typography style={{textAlign:'center'}}>No Records Found</Typography>
                    </Box>}
              </Grid>
            </Box>
          )}
        </Collapse>
      </TableCell>
    </TableRow>
  </>
    
  )
}

export default BatchDetailsUnitBox